<template>
  <div>
    <v-row>
      <v-col
        v-for="(evaluation, index) in model"
        :key="evaluation.idEvaluation || index"
        cols="12"
        sm="12"
        md="12"
      >
        <h3 align="left" class="mb-2">{{ evaluation.name }}:</h3>
        <v-row justify="center" :dense="dense">
          <v-col
            v-for="(question, subindex) in evaluation.questions"
            :key="question.idQuestion || subindex"
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
            cols="12"
            :md="calculeCols(evaluation.questions, question)"
          >
            <validation-provider
              v-slot="{ errors, invalid, touched }"
              :name="question.name"
              :rules="requiredValidation(question.required)"
            >
              <v-col v-if="question.typeAnswer === $cnst.ANSWER_TYPE_OPEN">
                <v-text-field
                  :label="question.name"
                  v-model="question.answerOpen"
                  :error-messages="errors"
                  :disabled="isViewDetailsForm"
                  :counter="200"
                  clearable
                  :clear-icon="$cnst.CLEAR_ICON"
                  :dense="dense"
                >
                  <v-icon
                    slot="append"
                    :color="touched && invalid ? 'error' : ''"
                  >
                    {{ touched && invalid ? "mdi-alert" : "" }}
                  </v-icon>
                </v-text-field>
              </v-col>

              <v-col v-else-if="question.typeAnswer === $cnst.ANSWER_TYPE_CLOSED">
                <div v-if="question.typeData === $cnst.ANSWER_TYPE_DATA_CHECKBOX">
                  <label>{{ question.name }}</label>
                  <v-row dense>
                    <v-col
                      cols="auto"
                      v-for="(answer, subindexans) in question.answers"
                      :key="subindexans"
                    >
                      <v-checkbox
                        v-model="question.answerClosed"
                        :label="answer.name"
                        :value="answer.idAnswer"
                        :error-messages="errors"
                        :disabled="isViewDetailsForm"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </div>
                <div v-else-if="question.typeData === $cnst.ANSWER_TYPE_DATA_CIRCULAR">
                  <label>{{ question.name }}</label>
                  <div class="circle-container">
                    <div
                      v-for="(answer, i) in question.answers"
                      :key="i"
                      class="circle-item"
                      :style="getItemStyle(i)"
                    >
                      <v-checkbox
                        v-model="question.answerClosed"
                        :label="answer.name"
                        :value="answer.idAnswer"
                        :error-messages="errors"
                        :disabled="isViewDetailsForm"
                        hide-details
                      />
                    </div>
                  </div>
                </div>
                <v-autocomplete
                  v-else
                  :label="question.name"
                  :items="question.answers"
                  v-model="question.answerClosed"
                  :error-messages="errors"
                  item-text="name"
                  item-value="idAnswer"
                  :disabled="isViewDetailsForm"
                  clearable
                  :clear-icon="$cnst.CLEAR_ICON"
                  no-data-text="Sin resultados disponibles"
                  :dense="dense"
                >
                  <v-icon
                    slot="append"
                    :color="touched && invalid ? 'error' : ''"
                  >
                    {{ touched && invalid ? "mdi-alert" : "" }}
                  </v-icon>
                </v-autocomplete>
              </v-col>

              <v-col v-else-if="question.typeAnswer === $cnst.ANSWER_TYPE_MULTIPLE">
                <div v-if="question.typeData === $cnst.ANSWER_TYPE_DATA_CHECKBOX">
                  <label>{{ question.name }}</label>
                  <v-row dense>
                    <v-col
                      cols="auto"
                      v-for="(answer, subindexans) in question.answers"
                      :key="subindexans"
                    >
                      <v-checkbox
                        v-model="question.answersClosed"
                        :label="answer.name"
                        :value="answer.idAnswer"
                        hide-details
                        :error-messages="errors"
                        :disabled="isViewDetailsForm"
                      />
                    </v-col>
                  </v-row>
                </div>
                <div v-else-if="question.typeData === $cnst.ANSWER_TYPE_DATA_CIRCULAR">
                  <label>{{ question.name }}</label>
                  <div class="circle-container">
                    <div
                      v-for="(answer, i) in question.answers"
                      :key="i"
                      class="circle-item"
                      :style="getItemStyle(i)"
                    >
                      <v-checkbox
                        v-model="question.answersClosed"
                        :label="answer.name"
                        :value="answer.idAnswer"
                        :error-messages="errors"
                        :disabled="isViewDetailsForm"
                        hide-details
                      />
                    </div>
                  </div>
                </div>
                <v-autocomplete
                  v-else
                  :label="question.name"
                  :items="question.answers"
                  v-model="question.answersClosed"
                  :error-messages="errors"
                  item-text="name"
                  item-value="idAnswer"
                  :disabled="isViewDetailsForm"
                  clearable
                  :clear-icon="$cnst.CLEAR_ICON"
                  no-data-text="Sin resultados disponibles"
                  :dense="dense"
                  multiple
                  small-chips
                  :deletable-chips="!isViewDetailsForm"
                >
                  <v-icon
                    slot="append"
                    :color="touched && invalid ? 'error' : ''"
                  >
                    {{ touched && invalid ? "mdi-alert" : "" }}
                  </v-icon>
                </v-autocomplete>
              </v-col>
              <v-col v-else-if="question.typeAnswer === 4">
  <v-autocomplete
    :label="question.name"
    :items="question.answers"
    v-model="question.answersClosed"
    item-text="name"
    item-value="idAnswer"
    :error-messages="errors"
    :disabled="isViewDetailsForm"
    clearable
    :clear-icon="$cnst.CLEAR_ICON"
    no-data-text="Sin resultados disponibles"
    :dense="dense"
    multiple
    small-chips
    :deletable-chips="!isViewDetailsForm"
  >
  </v-autocomplete>
</v-col>
<v-text-field
    v-if="question.answersClosed.includes('AGIN-84')" 
    label="Otro"
    v-model="question.answerOpen"
    :disabled="isViewDetailsForm"
    clearable
    :clear-icon="$cnst.CLEAR_ICON"
    :dense="dense"
  />
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import Clock from "@/app/components/colposcopy/Clock.vue";

export default {
  props: {
    model: {
      type: Array,
      default: () => []
    },
    isViewDetailsForm: Boolean,
    cols: Number,
  },
  data() {
    return {
      dense: true,
      selectedAnswers: [],
      answers: [
        { id: 1, label: "1" },
        { id: 2, label: "2" },
        { id: 3, label: "3" },
        { id: 4, label: "4" },
        { id: 5, label: "5" },
        { id: 6, label: "6" },
        { id: 7, label: "7" },
        { id: 8, label: "8" },
        { id: 9, label: "9" },
        { id: 10, label: "10" },
        { id: 11, label: "11" },
        { id: 12, label: "12" },
      ],
    };
  },
  components: {
    ValidationProvider,
    Clock,
  },
  mounted() {
    console.log('Valores que tengo en model:', this.model);
  },
  watch: {
  model: {
    immediate: true,
    deep: true,
    handler(newVal) {
      if (!newVal || !newVal.length) return

      const colposcopia = newVal.find(e => e.name === 'HALLAZGOS COLPOSCOPIA')
      if (!colposcopia) return

      const localizacionIndex = colposcopia.questions.findIndex(q => q.idQuestion === 'QGIN-20')
      const resultadoIndex = colposcopia.questions.findIndex(q => q.idQuestion === 'QGIN-21')

      if (localizacionIndex !== -1 && resultadoIndex !== -1) {
        const tmp = colposcopia.questions[localizacionIndex]
        colposcopia.questions[localizacionIndex] = colposcopia.questions[resultadoIndex]
        colposcopia.questions[resultadoIndex] = tmp
      }
      colposcopia.questions.forEach(question => {
        if (question.typeAnswer === 4) {
          if (question.answersClosed?.includes('AGIN-84') && question.answerClosed) {
            question.answerOpen = question.answerClosed
          }
        }
      })
    }
  }
},

  methods: {
    calculeCols(quantityQuestions, question) {
      switch (quantityQuestions.length) {
        case 1:
          return "12";
        case 2:
          return "6";
        default:
          return "4";
      }
    },
    requiredValidation(validation) {
      return validation ? "required|max:200" : "max:200";
    },
    getItemStyle(index) {
      const angle = ((index / this.answers.length) * 360) - 90;
      const radius = 100; 
      const x = radius * Math.cos((angle * Math.PI) / 180);
      const y = radius * Math.sin((angle * Math.PI) / 180);
      return {
        transform: `translate(${x}px, ${y}px)`,
      };
    },
  },
};
</script>

<style>
.circle-container {
  position: relative;
  margin-top: 90px !important;
  width: 200px;
  height: 110px;
  margin: auto;
}
.circle-item {
  position: absolute;
  margin-left: 50%;
}
</style>
